<template>
  <div class="show">
    <sc-btn type="link" :text="value" :handler="open" />
  </div>
</template>

<script lang="ts" setup>
import { computed, defineProps, shallowRef } from 'vue';
import { CustomFieldType } from '@/components/business/crud/interface/FieldType';
import { WidgetInfo } from '@/components/business/crud/widgets/WidgetContainer';
import { windows } from '@/components/common/window/Windows';
import ScBtn from '@/components/common/widget/ScBtn.vue';
import HasMany from '@/components/business/crud/widgets/impl/component/HasMany.vue';
import { app } from '@/models/App';

const props = defineProps<{
  propName: string;
  widget: CustomFieldType;
  info: WidgetInfo;
  data: any;
}>();

const value = computed(() => {
  if (props.data.devices.list.length === 0) {
    return '-';
  } else if (props.data.devices.list.length <= 3) {
    return props.data.devices.list.map((i: any) => i.name).join(';');
  } else {
    return (
      props.data.devices.list
        .slice(0, 3)
        .map((i: any) => i.name)
        .join(';') + `查看更多(${props.data.devices.count})`
    );
  }
});

async function open() {
  const id = windows.open({
    content: {
      type: 'component',
      component: shallowRef(HasMany),
      props: {
        propName: 'devices',
        info: {
          title: '绑定设备',
          status: 'edit',
        },
        widget: app.data.widgetMap.management.proxy.widgets.devices.type,
        data: props.data,
      },
    },
    title: '绑定设备详情',
    width: 1280,
    height: 800,
    padding: 20,
  });
  if (await windows.getCloseData(id)) {
    props.widget.extra?.refresh();
  }
}
</script>

<style lang="scss" scoped>
.show {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
}
</style>
